import _ from '../../core/utils'
import HINT_CONFIG from './config'

class HintClass {
    constructor() {
        this.DOM = {
            hint: HINT_CONFIG.hint,
            message: HINT_CONFIG.message
        }

        this.timeout = HINT_CONFIG.timeout
        this.status = HINT_CONFIG.status
    }

    _show( message = this.DOM.message.innerHTML, status = this.status.success ) {
        _.addClass( this.DOM.hint, 'fl__active' )
        _.addClass( this.DOM.hint, status )
        this.DOM.message.innerHTML = message     
    }

    _hide() {
        setTimeout( () => {
            _.removeClass( this.DOM.hint, 'fl__active' )
            _.removeClass( this.DOM.hint, this.status.error )
            _.removeClass( this.DOM.hint, this.status.success )
        }, this.timeout )
    }
}

const HINT = new HintClass()
export default HINT